import { IMAGE_MODE } from '@/models/layoutDesigner';

export const displayDefaultOptions = {
  rssName: true,
  content: true,
  image: true,
  imageWidth: 25,
  imageMode: IMAGE_MODE.CROP,
  feedNameSize: 16,
  titleFontSize: 30,
  contentSize: 20,
  contentLength: 200,
  spacing: 16,
  padding: 16,
  duration: 15,
};
